import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from "styled-components";
import { IconWithTooltip } from "../../floating";
import { Label } from "./Label";
const _LabelWithTooltip = ({ label, tooltipContent, className, tooltipSettings, required, }) => {
    return label ? (_jsxs(Wrapper, { className: className, children: [label && (_jsxs(Label, { children: [label, required && _jsx(Required, { children: "*" })] })), tooltipContent && _jsx(IconWithTooltip, { content: tooltipContent, ...tooltipSettings })] })) : null;
};
const Wrapper = styled.div `
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.sp4};
  margin-bottom: ${(p) => p.theme.spacing.sp4};
`;
const Required = styled.span `
  color: ${({ theme }) => theme.systemColors.red400};
  margin-left: ${(p) => p.theme.spacing.sp4};
`;
export const LabelWithTooltip = Object.assign(_LabelWithTooltip, {
    Wrapper,
    Label,
    Required,
});
